import { ComponentType } from 'react';
import { EdgeProps } from 'reactflow';
import { AddStepEdge } from 'assets/js/pages/engage/workflows/components/AddStepEdge';
import CustomBaseEdge from 'assets/js/pages/engage/workflows/components/CustomBaseEdge';
import { EdgeTypeEnum } from 'constants/workflows';

const edgeTypes: {
    [key in EdgeTypeEnum]?: ComponentType<EdgeProps>;
} = {
    [EdgeTypeEnum.BASE]: CustomBaseEdge,
    [EdgeTypeEnum.ADD_STEP]: AddStepEdge,
};

export { edgeTypes };
